<!-- <div
[attr.aria-label]="'Connection lost' | translate"
class="stream-notification"
*ngIf="isEndpointSick"
translate
>
Connection lost
</div> -->

@if (isPopedOut) {
<div
  [aria-label]="'Video is poped out' | translate"
  class="stream-poped-out"
  translate
>
  Video is poped out
</div>
}

<app-stream-view
  #streamView
  [class.hidden]="isMutedVideo || isFreezeFrameVisible || isPopedOut"
  [id]="stream.id"
  [type]="stream.type"
  [muted]="isLocal"
  (autoplayBlocked)="autoplayBlocked($event)"
  (mediaElementReady)="streamElementReady($event)"
  (mediaElementDestroyed)="streamElementDestroyed($event)"
>
</app-stream-view>

@if (isFilterLoading) {
<av-spinner size="md"></av-spinner>
} @if (!isScreen && isStreamElementReady) {
<app-freeze-frame
  [stream]="stream"
  [mirror]="isMirror"
  [blur]="isFreezeFrameBlurred"
  [class.blur]="isFreezeFrameBlurred"
  [class.open]="isFreezeFrameVisible"
  [class.zoom]="isZoomOn"
  [render]="isFreezeFrameVisible"
>
</app-freeze-frame>
} @if (isScreenHelpActive()) {
<div class="tile-screen-prompt">
  <h1 translate>You are presenting</h1>
  <button
    avButton
    ofType="stroked"
    [themable]="false"
    (click)="stopScreen()"
    translate
    data-tid="tile/stop-screenshare"
  >
    Stop presenting
  </button>
  @if (isMirroringHelpActive) {
  <div class="container-pad-md fx-column">
    <small translate class="text-muted"
      >To avoid mirroring don't share your entire screen or browser
      window.</small
    >
    <small translate class="text-muted"
      >Share just a tab or a different window instead.</small
    >
  </div>
  }
</div>
} @if (isDisplayNameAvailable()) {
<div
  [attr.aria-label]="
    ('Participant\'s name is ' | translate) + ' ' + displayName()
  "
  class="tile-name"
  [class.hidden]="isHiddenTooSmall()"
  [class.tile-name-volume]="isMutedVideo && avatar()"
  data-tid="tile/participant-name"
>
  {{ displayName() }}
</div>
} @if (isMutedVideo && avatar()) {
<div class="tile-avatar">
  <img
    alt="{{ 'Participant avatar' | translate }}"
    [attr.aria-label]="'Participant avatar' | translate"
    [src]="avatar()"
    (error)="avatarError()"
  />
</div>
} @if (isMutedVideo && !isAIAgent()) {
<app-volume-indicator
  [class.small-avatar]="avatar()"
  [class.small]="isLayoutFloating() || avatar()"
  [stream]="stream"
  [muted]="isMutedAudio"
>
</app-volume-indicator>
} @if (isSketchActive && !isWhisper) {
<div
  class="sketch-actions"
  [class.sketch-actions-condensed]="isSketchActionsCondensed"
>
  <app-point-controls
    [stream]="stream"
    [interaction]="interaction"
    [column]="isSketchActionsCondensed"
    (controlSelected)="pointControlSelected()"
  >
  </app-point-controls>
  @if (isSketchSupported) {
  <app-sketch-controls
    [room]="sketchId()"
    [stream]="stream"
    [column]="isSketchActionsCondensed"
    (controlStateChanged)="sketchControlChanged($event)"
  >
  </app-sketch-controls>
  }
</div>
} @if (isSketchSupported) {
<app-sketch-area
  class="sketch-area"
  id="{{ sketchId() }}"
  [endpoint]="stream.originator"
  [sync]="true"
  [stream]="stream"
  [class.sketch-area-active]="isSketchAreaActive()"
  [class.sketch-area-focused]="isSketchControlActive"
  (connected)="sketchConnected($event)"
  (ended)="sketchEnded($event)"
>
</app-sketch-area>
}

@if (!!stream && isAIAgent()) {
<app-audio-bubble [streamId]="stream?.id"></app-audio-bubble>
}

<ng-content></ng-content>
